import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Flex } from 'antd';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { EvidenceUploadDialog } from './EvidenceUploadDialog';
import { DocType } from 'enums';
import { EvidenceTaskName } from 'api/brokerCases/types';
import { PageURL } from 'router/pageURL';
import { TypedFormatMessageFn } from 'types/intl';

export interface IEvidenceUploadActionsProps {
  caseId: string;
  individualId?: string;
  taskId: string;
  showDownloadForm?: boolean;
  taskName: EvidenceTaskName;
  taskDocumentType?: DocType;
  uploadDescriptionRequired?: boolean;
  isUploadDisabled?: boolean;
  onProgressLoadingChange: (isLoading: boolean) => void;
}

const openGiftedDepositDeclarationForm = () => {
  window.open(PageURL.GIFTED_DEPOSIT_DECLARATION_FORM, '_blank', 'noreferrer');
};

export const EvidenceUploadAction = ({
  showDownloadForm = false,
  taskName,
  caseId,
  individualId,
  taskId,
  taskDocumentType,
  uploadDescriptionRequired = false,
  isUploadDisabled = false,
  onProgressLoadingChange,
}: IEvidenceUploadActionsProps) => {
  const { formatMessage }: { formatMessage: TypedFormatMessageFn } = useIntl();
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);

  return (
    <>
      <Flex align='center' className='gap-2'>
        {showDownloadForm && (
          <Button
            type='text'
            className='flex items-center gap-2 border-0 bg-transparent px-4 py-1.5 shadow-none'
            onClick={openGiftedDepositDeclarationForm}
            icon={<DownloadOutlined className='text-sm leading-none' />}
          >
            <span className='text-xs font-normal leading-5'>
              {formatMessage({ id: 'evidence.uploadAction.downloadForm' })}
            </span>
          </Button>
        )}
        <Button
          type='default'
          className='flex items-center gap-2 border border-slate-300 bg-transparent px-4 py-1.5 shadow-none'
          icon={<UploadOutlined className='text-sm leading-none' />}
          disabled={isUploadDisabled}
          onClick={() => setUploadDialogOpen(true)}
        >
          <span className='text-xs font-normal leading-5'>{formatMessage({ id: 'evidence.uploadAction.upload' })}</span>
        </Button>
      </Flex>
      {uploadDialogOpen && (
        <EvidenceUploadDialog
          open={uploadDialogOpen}
          onCancel={() => setUploadDialogOpen(false)}
          onSuccess={() => setUploadDialogOpen(false)}
          taskName={taskName}
          caseId={caseId}
          individualId={individualId}
          taskId={taskId}
          taskDocumentType={taskDocumentType}
          uploadDescriptionRequired={uploadDescriptionRequired}
          onProgressLoadingChange={onProgressLoadingChange}
        />
      )}
    </>
  );
};
